import styled, { css } from "styled-components";
import * as Popover from "@radix-ui/react-popover";

export const TimelineWrapper = styled.div`
  max-width: 992px;
  margin: 8px auto 24px;

  @media (max-width: 992px) {
    margin-left: 8px;
  }
`;

export const TimelineTrack = styled.div<{
  lastCompletedIndex: number;
  total: number;
}>`
  display: flex;
  position: relative;
  gap: 12px;

  &::before {
    content: "";
    position: absolute;
    top: 9px;
    left: ${({ total }) => `calc(50% / ${total})`};
    right: ${({ total }) => `calc(50% / ${total})`};
    height: 3px;
    background: #d1d5db;
    z-index: 0;
  }

  &::after {
    content: "";
    position: absolute;
    top: 9px;
    left: ${({ total }) => `calc(50% / ${total})`};
    width: ${({ lastCompletedIndex, total }) =>
      total > 1
        ? `calc(${lastCompletedIndex} / ${
            total - 1
          } * (100% - (100% / ${total})))`
        : "0px"};
    height: 3px;
    background: #1f4ca0;
    z-index: 1;
    transition: width 0.6s ease;
  }

  @media (max-width: 992px) {
    flex-direction: column;
    gap: 24px;

    &::before {
      top: 0;
      left: 8px;
      right: auto;
      width: 3px;
      height: 100%;
    }

    &::after {
      top: 0;
      left: 8px;
      width: 3px;
      height: ${({ lastCompletedIndex, total }) =>
        total > 1 && lastCompletedIndex !== 0
          ? `calc(${lastCompletedIndex} / ${total - 1} * 100%)`
          : "28px"};
      transition: height 0.6s ease;
    }
  }
`;

export const TimelineItem = styled.div<{ pending: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${({ pending }) =>
    pending &&
    css`
      ${TimelineDot} {
        border-color: #d1d5db;
        background: #9ca3af;
      }

      ${CardLabel},
      ${CardValue} {
        color: #9ca3af;
      }
    `}

  @media (max-width: 992px) {
    flex-direction: row;
    gap: 16px;
    width: 100%;
  }
`;

export const TimelineDot = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 4px solid;
  flex-shrink: 0;
  z-index: 3;
  border-color: #ffffff50;
  background: #1f4ca0;
`;

export const TimelineCard = styled.div`
  margin-top: 12px;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;

  @media (max-width: 992px) {
    margin-top: 0;
    text-align: left;
  }
`;

export const CardLabel = styled.span`
  font-size: 14px;
  font-weight: bold;
  line-height: 1.2;
  margin-bottom: 4px;
  text-transform: capitalize;
`;

export const CardDate = styled.span`
  font-size: 12px;
  color: #9ca3af;
`;

export const CardValue = styled.span`
  font-size: 12px;
  font-weight: bold;
`;

export const DetailsPopoverTrigger = styled(Popover.Trigger)`
  font-weight: bold;
  font-size: 12px;
  margin: 0;
  padding: 0;
  border: 0;
  background-color: transparent;
  color: #1f4ca0;

  &:hover {
    text-decoration: underline;
  }
`;

export const DetailsPopoverContent = styled(Popover.Content)`
  margin-top: 4px;
  width: 280px;
  padding: 12px 16px;
  background: white;
  border: 1px solid #e2e2e2;
  border-radius: 8px;
  box-shadow: 0px 0px 12px 0px #00000012;
  z-index: 10;
`;

export const DetailsTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const DetailsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  font-size: 14px;
`;

export const DetailsLabel = styled.span`
  color: #6b7280;
  font-weight: 500;
`;

export const DetailsValue = styled.span`
  color: #1f2937;
  font-weight: 600;
  text-align: right;
`;
